import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "";
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

if (SUPABASE_URL.includes('dghuyetpmlcddwerteyg') && process.env.NODE_ENV === 'test') {
  throw new Error('SAFETY: Test environment pointing at production Supabase. Set REACT_APP_SUPABASE_URL to staging.');
}

// PKCE (#1503 P1-6): an OAuth callback carries a one-time code that only the device holding the
// verifier can redeem. The implicit flow put tokens in the URL, which a crafted link could replay.
export const supabase = SUPABASE_URL && SUPABASE_ANON_KEY
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, { auth: { flowType: 'pkce' } })
  : null;
